var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "tool" }, [
                  _c("h4", [_vm._v("选择客户")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客户",
                            loading: _vm.customerLoading,
                            filterable: ""
                          },
                          on: { change: _vm.customerChange },
                          model: {
                            value: _vm.customerValue,
                            callback: function($$v) {
                              _vm.customerValue = $$v
                            },
                            expression: "customerValue"
                          }
                        },
                        _vm._l(_vm.customerData, function(item) {
                          return _c("el-option", {
                            key: item.client_id,
                            attrs: {
                              label: item.number + " " + item.client_name,
                              value: item.client_id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("div", { staticClass: "page_header" }, [
                    _c("i", {
                      staticClass: "el-icon-picture-outline header_icon"
                    }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("平面图转彩平")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("h5", [_vm._v("上传平面图")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload_area" },
                    [
                      !_vm.uploadedFloorplan
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload_dragger",
                              attrs: {
                                drag: "",
                                action: "",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.handleFloorplanUpload,
                                accept: "image/*"
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-upload" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "el-upload__text" }, [
                                _vm._v("将文件拖到此处，或"),
                                _c("em", [_vm._v("点击上传")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [_vm._v("支持 JPG、PNG 格式图片")]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "preview_area" },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.uploadedFloorplan,
                                  alt: "预览图"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "clear_btn",
                                  attrs: { type: "danger", size: "small" },
                                  on: { click: _vm.clearFloorplan }
                                },
                                [
                                  _c("i", { staticClass: "el-icon-delete" }),
                                  _vm._v(" 清除\n              ")
                                ]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("div", { staticClass: "style_header" }, [
                    _c("h5", [_vm._v("选择风格")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "hint" }, [_vm._v("（可多选）")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "style_options" },
                    _vm._l(_vm.styles, function(style) {
                      return _c(
                        "div",
                        {
                          key: style.id,
                          class: [
                            "style_item",
                            {
                              selected: _vm.isStyleSelected(style.id),
                              full_width: style.id === "custom"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.toggleStyle(style.id)
                            }
                          }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { value: _vm.isStyleSelected(style.id) },
                            on: {
                              change: function($event) {
                                return _vm.toggleStyle(style.id)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "style_info" }, [
                            _c("span", { staticClass: "style_name" }, [
                              _vm._v(_vm._s(style.name))
                            ])
                          ])
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isCustomSelected
                    ? _c(
                        "div",
                        { staticClass: "custom_style_input" },
                        [
                          _c("h5", [_vm._v("自定义风格描述")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: "描述您想要的风格...",
                              clearable: ""
                            },
                            model: {
                              value: _vm.customStyle,
                              callback: function($$v) {
                                _vm.customStyle = $$v
                              },
                              expression: "customStyle"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info_card" }, [
                  _c("div", { staticClass: "info_row" }, [
                    _c("span", { staticClass: "info_label" }, [
                      _vm._v("生成数量")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info_value" }, [
                      _vm._v(_vm._s(_vm.generationCount) + " 张")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info_hint" }, [
                    _vm._v(
                      "\n            已选择 " +
                        _vm._s(_vm.selectedStyles.length) +
                        " 个风格，每个风格生成 1 张效果图\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn_save" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "success",
                          loading: _vm.isGenerating,
                          disabled: !_vm.uploadedFloorplan || !_vm.customerValue
                        },
                        on: { click: _vm.handleGenerate }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isGenerating ? "生成中..." : "立即生成"
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        "（本月剩余使用额度 " +
                          _vm._s(_vm.global.money) +
                          "元）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.generatedImages.length > 0
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("生成记录")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "result_grid" },
                        _vm._l(_vm.generatedImages, function(img, index) {
                          return _c(
                            "div",
                            {
                              key: "result" + index,
                              staticClass: "result_item"
                            },
                            [
                              img.status === "pending"
                                ? _c("div", { staticClass: "result_loading" }, [
                                    _c("i", { staticClass: "el-icon-loading" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(img.style) + " 生成中...")
                                    ])
                                  ])
                                : img.status === "error"
                                ? _c("div", { staticClass: "result_error" }, [
                                    _c("i", { staticClass: "el-icon-warning" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(img.style) + " 生成失败")
                                    ])
                                  ])
                                : [
                                    _c("img", {
                                      staticClass: "result_image",
                                      attrs: { src: img.url, alt: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewImage(img.url)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "result_info" }, [
                                      _c("p", { staticClass: "result_title" }, [
                                        _vm._v(_vm._s(img.style))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "result_actions" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                plain: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleCollect(img)
                                                }
                                              }
                                            },
                                            [_vm._v("收藏")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                plain: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleDownload(img)
                                                }
                                              }
                                            },
                                            [_vm._v("下载")]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.exampleList.length > 0
                  ? _c("div", { staticClass: "example_section" }, [
                      _c("div", { staticClass: "example_header" }, [
                        _c("h5", [_vm._v("优质案例")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "example_grid" },
                        _vm._l(_vm.exampleList, function(item) {
                          return _c(
                            "div",
                            {
                              key: "example" + item.id,
                              staticClass: "example_item",
                              on: {
                                click: function($event) {
                                  return _vm.previewExample(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.photo_url +
                                    "?x-oss-process=image/resize,w_300",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    width: "auto",
                    "close-on-click-modal": true,
                    "custom-class": "image-preview-dialog",
                    "modal-append-to-body": true,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.previewVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "preview-dialog-image",
                    attrs: { src: _vm.previewImageUrl }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "示例详情",
                    visible: _vm.exampleDetailVisible,
                    width: "80%",
                    top: "5vh",
                    "close-on-click-modal": true,
                    "custom-class": "example-detail-dialog"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.exampleDetailVisible = $event
                    }
                  }
                },
                [
                  _vm.currentExample
                    ? _c("div", { staticClass: "example_detail" }, [
                        _vm.currentExample.original_photo_url
                          ? _c("div", { staticClass: "detail_images_row" }, [
                              _c("div", { staticClass: "image_item" }, [
                                _c("p", { staticClass: "image_label" }, [
                                  _vm._v("原始图片")
                                ]),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.original_photo_url,
                                    alt: "原始图"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "image_item" }, [
                                _c("p", { staticClass: "image_label" }, [
                                  _vm._v("生成结果")
                                ]),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.photo_url,
                                    alt: "生成结果"
                                  }
                                })
                              ])
                            ])
                          : _c("div", { staticClass: "detail_single_layout" }, [
                              _c("div", { staticClass: "detail_left" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.currentExample.photo_url,
                                    alt: ""
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail_right" }, [
                                _c("div", { staticClass: "detail_item" }, [
                                  _c("label", [_vm._v("提示词/描述：")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.currentExample.description)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "detail_item" }, [
                                  _c("label", [_vm._v("使用模型：")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.currentExample.model_name)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.currentExample.style_type
                                  ? _c("div", { staticClass: "detail_item" }, [
                                      _c("label", [_vm._v("风格类型：")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.currentExample.style_type)
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentExample.space_type
                                  ? _c("div", { staticClass: "detail_item" }, [
                                      _c("label", [_vm._v("空间类型：")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.currentExample.space_type)
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "detail_actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.useThisExample }
                                      },
                                      [_vm._v("使用此提示词")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]),
                        _vm._v(" "),
                        _vm.currentExample.original_photo_url
                          ? _c("div", { staticClass: "detail_info_bottom" }, [
                              _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("提示词/描述：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.description))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("使用模型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.model_name))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.currentExample.style_type
                                ? _c("div", { staticClass: "detail_item" }, [
                                    _c("label", [_vm._v("风格类型：")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.currentExample.style_type)
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentExample.space_type
                                ? _c("div", { staticClass: "detail_item" }, [
                                    _c("label", [_vm._v("空间类型：")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.currentExample.space_type)
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detail_actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: { click: _vm.useThisExample }
                                    },
                                    [_vm._v("使用此提示词")]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06c15e10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c15e10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FloorplanToColor/Index.vue
// module id = null
// module chunks = 